import { render, staticRenderFns } from "./DevicePhoneDetails.vue?vue&type=template&id=0ac47f2c&scoped=true"
import script from "./DevicePhoneDetails.vue?vue&type=script&lang=js"
export * from "./DevicePhoneDetails.vue?vue&type=script&lang=js"
import style0 from "./DevicePhoneDetails.vue?vue&type=style&index=0&id=0ac47f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac47f2c",
  null
  
)

export default component.exports